import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card h-100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-accent text-white font-weight-bold" }, " Daftar Uang Tips ", -1)
const _hoisted_3 = { class: "table-responsive" }
const _hoisted_4 = { class: "table" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-dark text-white" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "No"),
    /*#__PURE__*/_createElementVNode("th", null, "Jumlah Uang"),
    /*#__PURE__*/_createElementVNode("th", null, "Keterangan")
  ])
], -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "7",
  class: "text-center text-muted"
}, "Belum ada data", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 0,
  class: "bg-light"
}
const _hoisted_10 = {
  colspan: "7",
  class: "text-center text-muted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("table", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("tbody", null, [
          (_ctx.dataEmpty)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_6, _hoisted_8))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.uangTips, (uangTip, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: uangTip.r_u_t_id
                }, [
                  _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.currency(uangTip.r_u_t_nominal,'')), 1),
                  _createElementVNode("td", null, _toDisplayString(uangTip.r_u_t_keterangan), 1)
                ]))
              }), 128))
        ]),
        (!_ctx.dataEmpty)
          ? (_openBlock(), _createElementBlock("tfoot", _hoisted_9, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_10, " TOTAL PEMASUKAN : " + _toDisplayString(_ctx.currency(_ctx.total,'')), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}